import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';

import PlaceholderText from '../partials/PlaceholderText';
import CardTitle from '../typography/CardTitle';
import HorizontalCard from './HorizontalCard';

import styles from '../../styles/cards/region-horizontal-card.module.css';

interface RegionHorizontalCardProps extends Partial<Region> {
    placeholder?: boolean;
    withBorder?: boolean;
    className?: string | null;
}
function RegionHorizontalCard({
    slug = null,
    label = null,
    placeholder = false,
    withBorder = false,
    className = null,
}: RegionHorizontalCardProps) {
    const url = useUrlGenerator();
    return (
        <HorizontalCard
            href={
                slug !== null
                    ? url('map.region', {
                          region: slug,
                      })
                    : null
            }
            className={classNames([
                styles.container,
                {
                    [styles.withBorder]: withBorder,
                },
                className,
            ])}
            innerClassName={styles.inner}
            thumbnailClassName={styles.thumbnailContainer}
        >
            <CardTitle tag="span" className={styles.title} placeholder={placeholder}>
                {label}
            </CardTitle>
        </HorizontalCard>
    );
}
export default RegionHorizontalCard;
